import { render, staticRenderFns } from "./AdminManageContactDetailsModal.vue?vue&type=template&id=5b0e46f9"
import script from "./AdminManageContactDetailsModal.vue?vue&type=script&lang=js"
export * from "./AdminManageContactDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports